var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterOpacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 23,
    viewBox: "0 0 55 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1394",
    "data-name": "Raggruppa 1394",
    transform: "translate(2768 -705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_896",
    "data-name": "Rettangolo 896",
    width: 55,
    height: 23,
    rx: 4,
    transform: "translate(-2768 705)",
    fill: "rgba(82,79,79,0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1890",
    "data-name": "Tracciato 1890",
    d: "M3.5-5.124l1.466-2.7H6.816L4.539-3.942,6.875,0H5L3.5-2.739,1.993,0H.118L2.455-3.942.177-7.82H2.03Zm4.51,5.8H6.852L9.731-7.82h1.155ZM17.55-6.515h-2.4V0H13.543V-6.515H11.18V-7.82h6.37Zm5.552,4.4.763-3.7h1.5L23.881,0h-1.3l-1.1-3.658L20.379,0H19.084L17.6-5.812h1.5l.757,3.7,1.063-3.7h1.123ZM27.7,0H26.146V-5.812H27.7ZM26.054-7.315a.764.764,0,0,1,.234-.575.878.878,0,0,1,.636-.226.88.88,0,0,1,.634.226.76.76,0,0,1,.236.575.762.762,0,0,1-.239.58.882.882,0,0,1-.631.226.882.882,0,0,1-.631-.226A.762.762,0,0,1,26.054-7.315Zm4.72.075v1.429h.994v1.139h-.994v2.9a.693.693,0,0,0,.124.462.62.62,0,0,0,.473.14,2.475,2.475,0,0,0,.457-.038V-.032a3.2,3.2,0,0,1-.94.14,1.482,1.482,0,0,1-1.665-1.649V-4.673h-.849V-5.812h.849V-7.24Zm3.651,0v1.429h.994v1.139h-.994v2.9a.693.693,0,0,0,.124.462.62.62,0,0,0,.473.14,2.475,2.475,0,0,0,.457-.038V-.032a3.2,3.2,0,0,1-.94.14,1.482,1.482,0,0,1-1.665-1.649V-4.673h-.849V-5.812h.849V-7.24ZM38.892.107a2.853,2.853,0,0,1-2.081-.784,2.787,2.787,0,0,1-.8-2.089v-.15a3.511,3.511,0,0,1,.338-1.566A2.483,2.483,0,0,1,37.3-5.546a2.691,2.691,0,0,1,1.415-.373,2.412,2.412,0,0,1,1.877.752,3.056,3.056,0,0,1,.685,2.132V-2.4h-3.7a1.442,1.442,0,0,0,.454.913,1.372,1.372,0,0,0,.959.344,1.675,1.675,0,0,0,1.4-.65l.763.854a2.33,2.33,0,0,1-.945.771A3.1,3.1,0,0,1,38.892.107Zm-.177-4.77a.972.972,0,0,0-.749.312,1.609,1.609,0,0,0-.368.892h2.159v-.124a1.147,1.147,0,0,0-.279-.8A1,1,0,0,0,38.715-4.662Zm6.648.306A4.217,4.217,0,0,0,44.8-4.4a1.137,1.137,0,0,0-1.155.6V0H42.1V-5.812h1.466l.043.693a1.438,1.438,0,0,1,1.294-.8,1.626,1.626,0,0,1,.483.07Z",
    transform: "translate(-2763 720.707)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterOpacity);
export default __webpack_public_path__ + "static/media/twitter-opacity.926a92073bb222a7ff9d68e338a3e77e.svg";
export { ForwardRef as ReactComponent };